/**
 * Formata uma duração em minutos pra string amigável.
 *
 * Casos:
 *   null/0     →  "—"
 *   1–59       →  "30min"
 *   múltiplos  →  "2h"
 *   misto      →  "1h 30min"
 *
 * Existe porque antes os componentes faziam `Math.floor(min / 60)` direto,
 * o que zera qualquer duração < 60min (curso de 30min virava "0h").
 */
export function formatDuration(minutes: number | null | undefined): string {
  if (!minutes || minutes <= 0) return '—'
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  if (hours === 0) return `${rest}min`
  if (rest === 0) return `${hours}h`
  return `${hours}h ${rest}min`
}
